<template>
  <!-- D-235 (A3): the widget's two announcement channels, and they are rendered
       UNCONDITIONALLY and empty rather than with `v-if`.
       🪤 That is the whole trick and it is easy to get wrong: a live region has to be
       in the DOM *before* its content changes, because AT announces the DIFF against
       what it last saw. A region that is created at the same moment it gains text is
       announced by nobody — it looks correct in a DOM inspector and does nothing. -->
  <div class="live-region">
    <div class="is-sr-only" role="status" aria-live="polite">{{ status }}</div>
    <div class="is-sr-only" role="alert">{{ failure }}</div>
  </div>
</template>

<script>
export default {
  name: 'live-region',
  props: {
    // State and progress: play, pause, loading, "link copied". Polite — it waits for a
    // gap rather than interrupting whatever the user is reading.
    status: {
      type: String,
      default() {
        return '';
      },
    },
    // 🔑 FAILURES ONLY. `role="alert"` is implicitly assertive: it interrupts. Putting
    // ordinary state through it is the hostile mode that teaches people to turn live
    // regions off, so the two channels are separate props rather than one with a
    // politeness flag — a flag is something a caller passes wrongly, two props are not.
    failure: {
      type: String,
      default() {
        return '';
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/_helpers';

// No layout of its own: both children are `.is-sr-only`, which is absolute and
// 0.01em, so this element is inert in every flow it is dropped into. That matters
// because it is mounted inside four different players' markup and must move no golden.
.live-region {
  position: absolute;
}
</style>
